$(document).ready(function () {
    // Use jQuery height method to retrieve the heights
    const getDOMElementHeight = (query) => $(query).outerHeight();

    // Use jQuery css method to apply css to DOM element
    const setCSSProperty = (query, property, value) => $(query).css(property, value);

    // Get the height of the mobile menu
    const mobileTopMenuHeight = getDOMElementHeight('#mobile-top-menu');
    const secondMenuHeight = getDOMElementHeight('#second-menu');

    // Set initial CSS properties
    setCSSProperty('#second-menu', 'top', '0px'); // Initially position the second menu

    // Animate the #mobile-top-menu-wrapper margin-bottom
    $('#mobile-top-menu-wrapper').animate(
        {
            marginBottom: `${mobileTopMenuHeight + secondMenuHeight - 2}px`
        },
        200 // Duration of the animation in milliseconds
    );

    // Animate the #second-menu top position
    $('#second-menu').animate(
        {
            top: `${mobileTopMenuHeight - 4}px`,
            margin: `2px 0`,
        },
        200 // Duration of the animation in milliseconds
    );
});